import http from './http-service.js';                 //连接接口文件
// import axios from "axios";

// fun_name 请求函数名
// param  请求参数（数组）
// request_path 请求路径，区分不同客户特殊处理事件
export const request = async function (fun_name, param, request_path = 'index.php', headers = 'application/x-www-form-urlencoded;charset=utf-8') {
  request_path = request_path == '' ? 'index.php' : request_path;

  // 处理特殊符号转义，不转义的话，参数传递后为变成空格
  let tmp_param = JSON.stringify(param);

  tmp_param = tmp_param.replace(/\+/g, "%2B");
  tmp_param = tmp_param.replace(/\&/g, "%26");
  tmp_param = tmp_param.replace(/\%/g, "%25");

  //   axios.post('/request/index.php?action=' + fun_name, param)
  //     .then((data) => { // 正确的回调
  // console.log(data.data);
  //       return data.data;
  //   })
  let result = await http('post', '/request/' + request_path + '?action=' + fun_name, tmp_param, headers);
  return result;
}

export const upload = async function (fun_name, param, request_path = 'index.php', headers = 'multipart/form-data') {
  request_path = request_path == '' ? 'index.php' : request_path;

  let result = await http('post', '/request/' + request_path + '?action=' + fun_name, param, headers);
  return result;
}

// export const check_login = function (param) {
//   return http('post', '/request/index.php?action=check_login', param)
// }

// export const get_menu = function () {
//   return http('post', '/request/index.php?action=get_menu')
// }

// export const check_login = function (param) {
//   return http('post', '/request/index.php?action=check_login', { qwe: e })    //post方法以及传参    qwe是字段   e是参数
// }

// export const three = function (e) {
//   return http('get', '/251280/12345?qwe=' + e)  //get方法以及传参      qwe是字段   e是参数
// }